export enum SisName {
	// stamm
	Person = 'Person',
	Task = 'Task',
	Holiday = 'holiday',
	// beweg per person
	Booking = 'booking',
	Persurl = 'persurl',
	V2 = 'v2',
	V2Data = 'v2Data', // v2Kont!
	Ist = 'Ist',
	StTagZu = 'StTagZu',
	PersStat = 'PersStat',
	VlFehl = 'VlFehl',
	PlanEvent = 'PlanEvent',
	PlanTempl = 'PlanTempl',
	TaskZu = 'TaskZu',
	StatusForecast = 'StatusForecast',
	// other, client-created entries
	SUM = 'SUM',
	SUM_TASK = 'SUM_TASK',
	BookingEnd = 'BookingEnd',
	KoKeyConf = "KoKeyConf",
	SollIst = 'SollIst',
}